import { Badge } from 'antd'
import styled from 'styled-components'
const { Ribbon } = Badge

const RibbonStyled = styled(Ribbon)`
  display: ${({ isVisible = true }) => (isVisible ? 'revert' : 'none')};
  border-radius: var(--card-radius) var(--card-radius) 0px var(--card-radius) !important;
`
export default RibbonStyled
